import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import { Height } from '@material-ui/icons'
import React, { FC } from 'react'

import useTranslate from '../../../../i18n/useTranslate'
interface ItemProps {
    title: string
    path: string
    onClick: (path: string) => void
}
const Items: FC<ItemProps> = ({ title, path, onClick }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'

    return (
        <Grid item xs={12}>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                className={classes.boxItem}
                p={5}
                onClick={() => onClick(path)}
            >
                {title}
            </Box>
        </Grid>
    )
}

const useStyles = makeStyles((theme) => ({
    boxItem: {
        wordBreak: 'break-word',
        height: '120px',
        cursor: 'pointer',
        fontWeight: 'bold',
        margin: ' 5px',
        border: '1px solid #bdbdbd',
        borderRadius: '6px',
        textAlign: 'center',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
            color: 'white',
            backgroundColor: theme.palette.primary.main,
        },
    },
}))

export default Items
